import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHouseOfferSearchParams } from '../../house-offer/context/HouseOfferSearchParamsContext';
import { useOffer } from '../../../context/OfferProvider';

import CustomContainer from '../../../components/CustomContainer';
import CustomerSection from './CustomerSection';
import PaymentSection from './PaymentSection';
import AdditionalInformationSection from './AdditionalInformationSection';
import OfferSummary from '../../house-offer/result/OfferSummary';
import SearchHouse from '../../../components/lakeview/searchHouse/SearchHouse';
import LightButton from '../../../components/button/LightButton';
import GoBackButton from '../../../components/GoBackButton';
import DivBetween from '../../../components/div/DivBetween';
import { Col, Row } from 'react-bootstrap';

import { useCheckoutState } from './hooks/useCheckoutState';
import ToggleViewSwitch from '../../../components/switch/ToggleViewSwitch';
import ReservationTimeline from '../../../components/lakeview/ReservationTimeline';

const ReservationChangePage = () => {
  const { reservationId, id } = useParams();
  const { searchParams } = useHouseOfferSearchParams();

  const {
    setCanModifyPayments,
    offerResult,
    setOfferResult,
    manualDiscounts,
    setManualDiscounts,
    manualAdditionalPayments,
    setManualAdditionalPayments,
  } = useOffer();

  useEffect(() => {
    setCanModifyPayments(true);
  }, []);

  const {
    customer,
    setCustomer,
    paymentSelections,
    setPaymentSelections,
    paymentOnBookingPercentage,
    securityDepositAmount,
    setPaymentOnBookingPercentage,
    setSecurityDepositAmount,
    additionalInformation,
    setAdditionalInformation,
    formKey,
    setFormKey,
    setNewCustomerReady,
    setPaymentReady,
    reservation,
    editMode,
    setEditMode,
    reserveHouse,
    isReadyToReserve,
    isLoading,
  } = useCheckoutState(reservationId, id);

  useEffect(() => {
    console.log('paymentSelections ', paymentSelections);
  }, [paymentSelections]);

  if (!searchParams || isLoading) return null;

  return (
    <CustomContainer
      title={
        <DivBetween className="w-100">
          <h4>{'Zmiana rezerwacji ' + reservationId}</h4>
          <div className="gap-2 d-flex">
            <LightButton show={!editMode} onClick={() => setEditMode(true)}>
              Zmień parametry
            </LightButton>
            <GoBackButton variant="outline-secondary" label="Anuluj" />
          </div>
        </DivBetween>
      }
    >
      <Col md={8}>
        <Row>
          {offerResult?.result?.paymentSummary && (
            <>
              <CustomerSection
                customer={customer}
                setCustomer={setCustomer}
                formKey={formKey}
                setFormKey={setFormKey}
                setNewCustomerReady={setNewCustomerReady}
              />
              <PaymentSection
                offerResult={offerResult}
                paymentSelections={paymentSelections}
                setPaymentSelections={setPaymentSelections}
                paymentOnBookingPercentage={paymentOnBookingPercentage}
                securityDepositAmount={securityDepositAmount}
                setPaymentReady={setPaymentReady}
                updatePaymentOnBookingPercentage={(data) =>
                  setPaymentOnBookingPercentage(
                    data?.paymentOnBookingPercentage,
                  )
                }
                updateSecurityDepositAmount={(data) => {
                  setSecurityDepositAmount(
                    data?.securityDepositAmount,
                  );
                }}
              />
              <AdditionalInformationSection
                additionalInformation={additionalInformation}
                updateAdditionalInformation={setAdditionalInformation}
              />
              {offerResult?.result?.cancellationRules && (
                <ReservationTimeline
                  cancellationRules={offerResult.result.cancellationRules}
                  arrivalDate={searchParams?.startDate}
                  departureDate={searchParams?.endDate}
                  currentRefundStatus={offerResult?.result?.currentRefundStatus}
                />
              )}
            </>
          )}
        </Row>
      </Col>

      <Col md={4}>
        {!editMode && (
          <ToggleViewSwitch
            leftTitle="Obecna oferta"
            rightTitle="Nowa oferta"
            style={{ position: 'sticky', top: '170px', zIndex: 10 }}
            left={
              <OfferSummary
                title="Obecna oferta"
                width={12}
                offer={reservation}
                reservation={true}
                show={!isLoading}
                readOnly={true}
              />
            }
            right={
              <OfferSummary
                title="Nowa oferta"
                width={12}
                onClickNext={
                  isReadyToReserve()
                    ? () => reserveHouse(searchParams)
                    : undefined
                }
                offer={offerResult?.result}
                nextLabel="Zmień rezerwację"
                show={!!offerResult?.result && !editMode}
                manualDiscounts={manualDiscounts}
                setManualDiscounts={setManualDiscounts}
                manualAdditionalPayments={manualAdditionalPayments}
                setManualAdditionalPayments={setManualAdditionalPayments}
              />
            }
          />
        )}
        <SearchHouse
          key={id}
          houseId={id}
          width={12}
          reservationId={reservationId}
          setResult={setOfferResult}
          onReset={() => setEditMode(false)}
          onSearchHouse={() => setEditMode(false)}
          manualDiscounts={manualDiscounts}
          manualAdditionalPayments={manualAdditionalPayments}
          paymentOnBookingPercentage={paymentOnBookingPercentage}
          securityDepositAmount={securityDepositAmount}
          paymentModel={paymentSelections?.paymentModel}
          show={editMode}
        />
      </Col>
    </CustomContainer>
  );
};

export default ReservationChangePage;
